const tp_url = 'https://api.trustpilot.com/v1/business-units/5bae2f308d99e600014b32ac';
const apikey = '8XnfBBjyvj01VkZP3xMGtX3W0QAvU39G';
const monthNames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

let horizontal = document.querySelectorAll('.trustpilot-horizontal'),
  vertical = document.querySelectorAll('.trustpilot-vertical'),
  compact = document.querySelectorAll('.trustpilot-compact'),
  slider = document.querySelectorAll('.trustpilot-slider'),
  boxes = document.querySelectorAll('.trustpilot-boxes'),
  score = document.querySelectorAll('.trustpilot-score');

if (horizontal.length || vertical.length || compact.length || score.length) {
  fetch(
    tp_url +
      '?' +
      new URLSearchParams({
        apikey
      })
  )
    .then(response => response.json())
    .then(data => {
      trustpilotHorizontal(data);
      trustpilotVertical(data);
      trustpilotCompact(data);
      trustpilotScore(data);
    })
    .catch(() => {});
}

if (slider.length) {
  trustpilotSlider();
}

if (boxes.length) {
  trustpilotBoxes();
}

function trustpilotHorizontal(data) {
  horizontal.forEach(element => {
    element.querySelector('.trustpilot-stars').src = 'https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-' + data.score.stars + '.svg';
    element.querySelector('.trustpilot-score').textContent = data.score.trustScore;
    element.querySelector('.trustpilot-amount').textContent = data.numberOfReviews.total;
  });
}

function trustpilotVertical(data) {
  vertical.forEach(element => {
    element.querySelector('.trustpilot-stars').src = 'https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-' + data.score.stars + '.svg';
    element.querySelector('.trustpilot-amount').textContent = data.numberOfReviews.total;
  });
}
function trustpilotCompact(data) {
  compact.forEach(element => {
    element.querySelector('.trustpilot-stars').src = 'https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-' + data.score.stars + '.svg';
    element.querySelector('.trustpilot-score').textContent = data.score.trustScore;
    element.querySelector('.trustpilot-amount').textContent = data.numberOfReviews.total;
  });
}

function trustpilotScore(data) {
  score.forEach(element => {
    element.textContent = data.score.trustScore.toString().replace('.', ',');
  });
}

function trustpilotSlider() {
  slider.forEach(element => {
    fetch(
      tp_url +
        '/reviews?' +
        new URLSearchParams({
          apikey,
          perPage: parseInt(element.dataset.entries),
          page: parseInt(element.dataset.page),
          tagValue: element.dataset.tag,
          stars: element.dataset.stars,
          language: en ? 'en' : 'de'
        })
    )
      .then(response => response.json())
      .then(data => {
        if (data.reviews.length) {
          const sliderWrapper = element.querySelector('.slider-wrapper');
          for (const review of data.reviews) {
            const d = new Date(review.createdAt);
            const box = document.createElement('div');
            box.classList.add('box', 'slide');
            box.innerHTML =
              '<div class="top"><img class="stars" width="118" height="22" alt="Trustpilot ' +
              review.stars +
              (en ? ' stars rating' : ' Sterne Bewertung') +
              '" src="https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-' +
              review.stars +
              '.svg"><span class="date">' +
              d.getUTCDate() +
              '. ' +
              monthNames[d.getUTCMonth()] +
              '</span></div><strong>' +
              review.title +
              '</strong><p>' +
              review.text +
              '</p><div class="author"><strong>' +
              review.consumer.displayName +
              '</strong><svg><use xlink:href="/assets/dist/sprite.svg#btn-check" /></svg><span>ottonova Kunde</span></div>';
            sliderWrapper.appendChild(box);
          }
          const load = element.querySelector('.load');
          load.setAttribute('initialized', '');
          const event = new CustomEvent('isInitialized');
          load.dispatchEvent(event);
        }
      })
      .catch(() => {});
  });
}

function trustpilotBoxes() {
  boxes.forEach(element => {
    element.trustPilotCurrent = parseInt(element.dataset.page);

    let loadBtn = element.querySelector('.load-more');

    loadBtn.addEventListener('click', e => {
      if (loadBtn.classList.contains('active')) {
        return;
      }
      loadBtn.classList.add('active');
      loadBtn.innerHTML = progressText;
      loadBoxes(element);
    });

    loadBoxes(element);
  });
}

function loadBoxes(element, callback) {
  let loadDiv = element.querySelector('.load'),
    loadBtn = element.querySelector('.load-more');

  fetch(
    tp_url +
      '/reviews?' +
      new URLSearchParams({
        apikey,
        perPage: parseInt(element.dataset.entries),
        page: element.trustPilotCurrent,
        tagValue: element.dataset.tag,
        stars: element.dataset.stars,
        language: en ? 'en' : 'de'
      })
  )
    .then(response => response.json())
    .then(data => {
      let array = data.reviews,
        newDiv = document.createElement('div');

      newDiv.classList.add('new');

      if (array.length) {
        element.trustPilotCurrent = parseInt(element.trustPilotCurrent) + 1;
        for (const review of array) {
          newDiv.appendChild(createBox(review.stars, review.consumer.displayName, review.title, review.text));
        }
        loadDiv.appendChild(newDiv);

        let animation = loadDiv.animate([{ height: loadDiv.offsetHeight + newDiv.offsetHeight }], {
          duration: 400
        });

        animation.onfinish = () => {
          newDiv.classList.add('show');
          loadDiv.removeAttribute('style');
          if (array.length < parseInt(element.dataset.entries)) {
            loadBtn.textContent = en ? 'No more reviews' : 'Keine weiteren Einträge';
          } else {
            loadBtn.classList.remove('active');
            loadBtn.textContent = en ? 'Load more reviews' : 'Mehr Bewertungen laden';
          }
          if (callback && typeof callback === 'function') {
            callback();
          }
        };
      }
    })
    .catch(() => {});
}

function createBox(stars, author, title, text) {
  let boxElem = document.createElement('div'),
    topElem = document.createElement('div'),
    authorElem = document.createElement('div'),
    titleElem = document.createElement('p'),
    textElem = document.createElement('div');

  boxElem.classList.add('box');
  topElem.classList.add('top');
  topElem.innerHTML = '<img class="stars" width="118" height="22" src="https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-' + stars + '.svg">';
  authorElem.classList.add('author');
  authorElem.innerHTML =
    '<strong>' + author + '</strong><svg><use xlink:href="/assets/dist/sprite.svg#btn-check" /></svg><span>' + (en ? 'verified ottonova customer' : 'Verifizierter ottonova Kunde') + '</span>';
  titleElem.innerHTML = title;
  textElem.classList.add('text');
  textElem.innerHTML = text;

  topElem.appendChild(authorElem);

  boxElem.appendChild(topElem);
  boxElem.appendChild(titleElem);
  boxElem.appendChild(textElem);
  return boxElem;
}
